import { cn } from '../../lib/utils.js'

function PageHeader({
  actions,
  children,
  className,
  eyebrow,
  description,
  title,
}) {
  return (
    <header className={cn('page-heading ui-page-header', className)}>
      <div className="ui-page-header-copy">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        {title && <h1>{title}</h1>}
        {description && <p>{description}</p>}
        {children}
      </div>
      {actions && <div className="ui-page-header-actions">{actions}</div>}
    </header>
  )
}

export { PageHeader }
